/*
 * @Author: zhouhm 1148305943@qq.com
 * @Date: 2025-08-25 17:15:05
 * @LastEditors: zhouhm 1148305943@qq.com
 * @LastEditTime: 2025-09-22 14:59:30
 * @FilePath: \road_monitor_app\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import Vue from "vue";
import router from "@/router";
// 创建 axios 实例
let baseURL = "/api";
const request = axios.create({
    // API 请求的默认前缀
    baseURL: baseURL,
    timeout: 600000, // 请求超时时间
    withCredentials: true,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        'authkey': generateTimestampId()
    }
});

// 生成：当前时间戳 + 16位数字字母随机串
function generateTimestampId() {
    const timestamp = Date.now().toString();
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let rand = '';

    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        // 浏览器安全随机
        const arr = new Uint32Array(16);
        crypto.getRandomValues(arr);
        for (const n of arr) rand += chars[n % chars.length];
    } else {
        try {
            // Node.js 安全随机
            const { randomBytes } = require('crypto');
            const buf = randomBytes(16);
            for (const n of buf) rand += chars[n % chars.length];
        } catch (err) {
            // 兜底
            for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)];
        }
    }

    return timestamp + rand;
}

// request拦截器
request.interceptors.request.use(
    config => {
        const token = window.sessionStorage.getItem("token");
        // 让每个请求携带自定义 token
        config.headers["from"] = "app";
        // 如果 token 存在
        if (token) {
            config.headers["token"] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// response拦截器
request.interceptors.response.use(
    response => {
        if (response.data && response.data.code === 401) {
            // 401, token失效
            Vue.cookie.delete("token");
            router.push({ name: "HomePage" });
        }
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);
export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js